import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
ChartJS.register(CategoryScale, LinearScale, BarElement);

const PriceGraph = () => {
  const data = {
    labels: [
      "Oct 2023",
      "Jan 2024",
      "Apr 2024",
      "Jul 2024",
      "Oct 2024",
      "Jan 2025",
      "Apr 2025",
      "Jul 2025",
    ],
    datasets: [
      {
        label: "Price Sq/Ft",
        data: [6000, 6100, 6000, 6200, 6000, 6200, 6600, 7900],
        backgroundColor: "rgba(218, 54, 26, 0.8)", // bar color
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: { display: true, text: "Monthly Sales Bar Chart" },
    },
  };

  return (
    <>
      <Bar data={data} options={options} />
    </>
  );
};

export default PriceGraph;
